import React, { useState, useEffect } from "react";
import axios from "axios";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import FileUpload from "./FileUpload";


import { readProduct, updateProduct } from "../../../function/product";
import { listCategory } from "../../../function/category";
import { listCategoryService } from "../../../function/categoryservice";
import { listServiceCentersByCategory } from "../../../function/servicecenter";
import DOMPurify from "dompurify";
import "./CreateProduct.css"; // ใช้สไตล์ pc-select ร่วมกับหน้า CreateProduct

const UpdateProduct = () => {
  const initialstate = {
    title: "",
    description: "",
    categories: [],
    category: "",
    // ⚠️ ใหม่: หมวดหมู่สินค้าจริงๆ (แยกจาก category ด้านบนที่จริงๆ คือแบรนด์)
    productCategory: "",
    price: "",
    quantity: "",
    images: [],
    points: "",
    employeeDiscount: "",
  };

  const params = useParams();
  const navigate = useNavigate();
  const { user } = useSelector((state) => ({ ...state }));

  const [values, setValues] = useState(initialstate);
  const [category, setCategory] = useState([]);
  const [categoriesService, setCategoriesService] = useState([]);
  const [selectedSource, setSelectedSource] = useState("category");
  const [loading, setLoading] = useState(false);

  const [serviceCenters, setServiceCenters] = useState([]);
  const [selectedServiceCenters, setSelectedServiceCenters] = useState([]);
  const [showAddServiceCenter, setShowAddServiceCenter] = useState(false);
  const [newServiceCenter, setNewServiceCenter] = useState({
    name: "",
    province: "",
    image: "",
    latitude: "",
    longitude: "",
    mao: "",
  })

  // ⚠️ ใหม่: รายการหมวดหมู่สินค้าจริง (ดึงจาก ProductCategory model)
  const [productCategories, setProductCategories] = useState([]);
  const [loadingProductCategories, setLoadingProductCategories] = useState(false);

  useEffect(() => {
    loadData();
  }, []);
  useEffect(() => {
    if (values.category) {
      listServiceCentersByCategory(values.category._id || values.category)
        .then(res => setServiceCenters(res.data))
        .catch(() => setServiceCenters([]));
    } else {
      setServiceCenters([]);
    }
  }, [values.category]);

  useEffect(() => {
    if (values.serviceCenter) {
      setSelectedServiceCenters(values.serviceCenter.map(c => c._id || c));
    }
  }, [values.serviceCenter]);

  // ⚠️ ใหม่: โหลดหมวดหมู่สินค้าจริงตาม source ที่เลือก
  // หมายเหตุ: ตั้งใจไม่ clear values.productCategory ในนี้ เพราะตอนโหลดหน้าแรก
  // loadData() จะ setSelectedSource ทีหลัง (async) ถ้า clear ที่นี่จะไปลบค่าที่เพิ่งโหลดมาจาก DB ทิ้ง
  useEffect(() => {
    setLoadingProductCategories(true);
    axios
      .get(`${process.env.REACT_APP_API}/product-category?type=${selectedSource}&isActive=true`)
      .then((res) => setProductCategories(res.data))
      .catch((err) => {
        console.log(err);
        setProductCategories([]);
      })
      .finally(() => setLoadingProductCategories(false));
  }, [selectedSource]);

  const loadData = () => {
    readProduct(params.id)
      .then((res) => {
        setValues({ ...values, ...res.data });
        setSelectedSource(res.data.category ? "category" : "categoryService");
      })
      .catch((err) => {
        console.log(err);
      });

    listCategory(user.token)
      .then((res) => setCategory(res.data))
      .catch((err) => console.log(err));

    listCategoryService(user.token)
      .then((res) => setCategoriesService(res.data))
      .catch((err) => console.log(err));
  };


  const handleChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  // เปลี่ยน source ด้วยมือ (ผู้ใช้กดเลือกเอง) เท่านั้นถึงจะ clear หมวดหมู่เดิมทิ้ง
  // เพราะหมวดหมู่เดิมอาจไม่ตรงกลุ่มใหม่แล้ว
  const handleSourceChange = (e) => {
    setSelectedSource(e.target.value);
    setValues((prev) => ({ ...prev, productCategory: "" }));
  };

  const handleDescriptionChange = (value) => {
    console.log("New Description:", value); // ตรวจสอบค่า ReactQuill
    setValues((prevValues) => ({
      ...prevValues,
      description: value || "", // ป้องกัน null หรือ undefined
    }));
  };

  const handleServiceCenterChange = (e) => {
    const options = Array.from(e.target.selectedOptions, option => option.value);
    setSelectedServiceCenters(options);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    // ทำความสะอาด description
    const cleanDescription = DOMPurify.sanitize(values.description);

    console.log("Submitting values:", { ...values, description: cleanDescription });

    updateProduct(user.token, values._id, { ...values, description: cleanDescription, serviceCenter: selectedServiceCenters })
      .then(() => {
        setLoading(false);
        toast.success("อัพเดตสินค้าสำเร็จ");
        navigate("/admin/index");
      })
      .catch((err) => {
        setLoading(false);
        console.error("Update failed:", err.response ? err.response.data : err);
        toast.error("อัพเดตสินค้าไม่สำเร็จ");
      });
  };

  const handleAddServiceCenter = async () => {
    try {
      const payload = {
        name: newServiceCenter.name,
        province: newServiceCenter.province,
        image: newServiceCenter.image,
        location: {
          latitude: Number(newServiceCenter.latitude),
          longitude: Number(newServiceCenter.longitude),
          map: newServiceCenter.map,
        },
        category: [values.category._id || values.category],
        categoryType: selectedSource === "categoryService" ? "categoryservice" : "category",

      };
      const resCreate = await axios.post(`${process.env.REACT_APP_API}/service-centers`, payload);
      if (values.category) {
        const res = await listServiceCentersByCategory(values.category._id || values.category);
        setServiceCenters(res.data);

        if (resCreate.data && resCreate.data._id) {
          setSelectedServiceCenters(prev => [...prev, resCreate.data._id]);
        }
      }
      setShowAddServiceCenter(false);
      setNewServiceCenter({
        name: "",
        province: "",
        image: "",
        latitude: "",
        longitude: "",
        map: "",

      });
      toast.success("เพิ่ม Service Center สำเร็จ");
    } catch (error) {
      console.error("Error adding service center:", error);
      toast.error("เพิ่ม Service Center ไม่สำเร็จ");
    }
  }


  return (
    <div>
      {loading ? <h2>Loading...</h2> : <h2>Product Update</h2>}
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Title</label>
          <input
            className="form-control"
            type="text"
            name="title"
            value={values.title}
            onChange={handleChange}
          />
        </div>

        <div className="form-group">
          <label>Description</label>
          <ReactQuill value={values.description} onChange={handleDescriptionChange} />
        </div>

        <div className="form-group">
          <label>Price</label>
          <input
            className="form-control"
            type="number"
            name="price"
            value={values.price}
            onChange={handleChange}
          />
        </div>

        <div className="form-group">
          <label>Quantity</label>
          <input
            className="form-control"
            type="number"
            name="quantity"
            value={values.quantity}
            onChange={handleChange}
          />
        </div>
        <div className="form-group">
          <label>Point</label>
          <input
            className="form-control"
            type="number"
            name="points"
            value={values.points}
            onChange={handleChange}
            placeholder="คะแนนสะสม"
          />
        </div>
        <div className="form-group">
          <label>Employee Discount (%)</label>
          <input
            className="form-control"
            type="number"
            name="employeeDiscount"
            value={values.employeeDiscount || ""}
            onChange={handleChange}
            placeholder="เช่น 10 (หมายถึงลด 10%)"
          />
        </div>


        <div className="form-group">
          <label>Category Source</label>
          <select
            className="form-control"
            value={selectedSource}
            onChange={handleSourceChange}
          >
            <option value="category">Category</option>
            <option value="categoryService">Category Service</option>
          </select>
        </div>

        <div className="form-group">
          <label>Category <span className="pc-field-hint">(แบรนด์สินค้า)</span></label>
          <select
            className="form-control"
            name="category"
            value={values.category ? values.category._id : ""}
            onChange={handleChange}
            required
          >
            <option value="">-- กรุณาเลือก --</option>
            {selectedSource === "category" &&
              category.map((item) => (
                <option key={item._id} value={item._id}>
                  {item.name}
                </option>
              ))}
            {selectedSource === "categoryService" &&
              categoriesService.map((item) => (
                <option key={item._id} value={item._id}>
                  {item.name}
                </option>
              ))}
          </select>
        </div>

        {/* ⚠️ ใหม่: หมวดหมู่สินค้าจริงๆ แยกจาก Category (แบรนด์) ด้านบน */}
        <div className="pc-field-group">
          <label className="pc-field-label">
            หมวดหมู่สินค้า
            <span className="pc-field-hint">(แยกจากแบรนด์ด้านบน)</span>
          </label>
          <select
            className="pc-select"
            name="productCategory"
            value={values.productCategory ? (values.productCategory._id || values.productCategory) : ""}
            onChange={handleChange}
            disabled={loadingProductCategories}
          >
            <option value="">
              {loadingProductCategories ? "กำลังโหลด..." : "-- ไม่ระบุหมวดหมู่ --"}
            </option>
            {productCategories.map((item) => (
              <option key={item._id} value={item._id}>
                {item.name}
              </option>
            ))}
          </select>
          {!loadingProductCategories && productCategories.length === 0 && (
            <small className="pc-field-empty">
              ยังไม่มีหมวดหมู่ในกลุ่ม "{selectedSource === "category" ? "สินค้า" : "บริการ"}" นี้
            </small>
          )}
        </div>


        <FileUpload
          loading={loading}
          setLoading={setLoading}
          values={values}
          setValues={setValues}
        />
        <div className="form-group">
          <label>Service Center</label>
          <select
            className="form-control"
            multiple
            value={selectedServiceCenters}
            onChange={handleServiceCenterChange}
            disabled={!values.category}
          >
            {serviceCenters.map(center => (
              <option key={center._id} value={center._id}>
                {center.name} ({center.province})
              </option>
            ))}
          </select>
          <small className="text-muted">เลือก Service Center ได้หลายรายการ (กด Ctrl หรือ Cmd)</small>
          <br />
          <button
            type="button"
            className="btn btn-link p-0"
            onClick={() => setShowAddServiceCenter(!showAddServiceCenter)}
          >
            + เพิ่ม Service Center ใหม่
          </button>
          {showAddServiceCenter && (
            <div className="mt-2 border rounded p-2 bg-light">
              <input
                className="form-control mb-1"
                placeholder="ชื่อ Service Center"
                value={newServiceCenter.name}
                onChange={e => setNewServiceCenter({ ...newServiceCenter, name: e.target.value })}
                required
              />
              <input
                className="form-control mb-1"
                placeholder="จังหวัด"
                value={newServiceCenter.province}
                onChange={e => setNewServiceCenter({ ...newServiceCenter, province: e.target.value })}
                required
              />
              <input
                className="form-control mb-1"
                placeholder="URL รูปภาพ"
                value={newServiceCenter.image}
                onChange={e => setNewServiceCenter({ ...newServiceCenter, image: e.target.value })}
                required
              />
              <input
                className="form-control mb-1"
                placeholder="ละติจูด (Latitude)"
                type="number"
                value={newServiceCenter.latitude}
                onChange={e => setNewServiceCenter({ ...newServiceCenter, latitude: e.target.value })}
                required
              />
              <input
                className="form-control mb-1"
                placeholder="ลองจิจูด (Longitude)"
                type="number"
                value={newServiceCenter.longitude}
                onChange={e => setNewServiceCenter({ ...newServiceCenter, longitude: e.target.value })}
                required
              />
              <input
                className="form-control mb-1"
                placeholder="Google Map URL"
                onChange={e => setNewServiceCenter({ ...newServiceCenter, map: e.target.value })}
              />
              <button
                type="button"
                className="btn btn-success mt-2"
                onClick={handleAddServiceCenter}
              > บันทึก
              </button>
              <button
                type="button"
                className="btn btn-secondary mt-2 ms-2"
                onClick={() => setShowAddServiceCenter(false)}
              >
                ยกเลิก
              </button>


            </div>
          )}
        </div>

        <button className="btn btn-primary mt-2" disabled={loading}>
          {loading ? "Updating..." : "Submit"}
        </button>
      </form>
    </div>
  );
};

export default UpdateProduct;